import './assets/slick.1.9.0.min.js';
import ImageCarouselLightbox from './ImageCarouselLightbox.js';

class ImageCarousel {
  constructor($main) {
    console.log('ImageCarousel init');
    if (!this.initDomElements($main)) return false;
    this.slider = null;
    this.initSlider();
    this.initLightbox();
  }

  initDomElements($main) {
    this.domElements = {};
    this.domElements.main = $main;
    if (this.domElements.main.length < 1) return false;
    this.domElements.inside = this.domElements.main.find(
        '.image-carousel__inside');
    this.domElements.items = this.domElements.main.find(
        '.image-carousel__images');
    this.domElements.controls = this.domElements.main.find(
        '.image-carousel__controls');
    this.domElements.controls2 = this.domElements.main.find(
        '.image-carousel__controls-2');
    return true;
  }

  initSlider() {
    if (this.domElements.items.find('>*').length < 2) {
      return;
    }

    const options = {
      dots: true,
      arrows: true,
      slidesToScroll: 1,
      slidesToShow: 3,
      variableWidth: false,
      speed: 400,
      infinite: false,
      fade: false,
      autoplay: false,
      adaptiveHeight: true,
      appendArrows: this.domElements.controls,
      appendDots: this.domElements.controls2,
      nextArrow: '<button class="slick-next slick-arrow" aria-label="weiter" type="button" style=""></button>',
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="zurück" type="button" style=""></button>',

      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            adaptiveHeight: false
          }
        }
      ]
    };

    this.slider = this.domElements.items.slick(options);
  }

  initLightbox() {
    this.lightbox = new ImageCarouselLightbox(this.domElements.main[0], {
      onClose: (index) => {
        // Bring the slide of the last viewed image into view so the focus
        // returned by the lightbox lands on a visible trigger.
        if (this.slider && this.domElements.items.hasClass('slick-initialized')) {
          this.domElements.items.slick('slickGoTo', index, true);
        }
      }
    });
  }
}

export default ImageCarousel;
